import type { ReactNode } from 'react';
import { ChevronDown, ChevronUp } from '../../components/ui/icons';

export function SportAccordion({
  open,
  onToggle,
  icon,
  title,
  badge,
  subtitle,
  children
}: {
  open: boolean;
  onToggle: () => void;
  icon: ReactNode;
  title: string;
  badge: ReactNode;
  subtitle: string;
  children: ReactNode;
}) {
  return (
    <div className="overflow-hidden rounded-[22px] border border-black/[0.07] bg-white shadow-[0_10px_26px_-22px_rgba(20,20,50,0.4)]">
      <button
        type="button"
        onClick={onToggle}
        className="tap flex w-full items-center gap-[13px] p-[15px_16px] text-left"
      >
        {icon}
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-[7px]">
            <span className="text-[16px] font-extrabold tracking-tight text-ink">{title}</span>
            {badge}
          </div>
          <div className="mt-0.5 text-[12px] font-medium text-ink2">{subtitle}</div>
        </div>
        <div className="grid h-[30px] w-[30px] shrink-0 place-items-center rounded-full bg-[#F2F2F6]">
          {open ? (
            <ChevronUp width={15} height={15} strokeWidth={2.6} className="text-ink2" />
          ) : (
            <ChevronDown width={15} height={15} strokeWidth={2.6} className="text-ink2" />
          )}
        </div>
      </button>
      {open ? <div className="flex flex-col gap-[7px] px-3 pb-3">{children}</div> : null}
    </div>
  );
}
